import { styled } from "theme/default/styled";
import { setFlexDF } from "theme/setter/setFlexValues/setFlexDF";

export const SSelectedActionStepButtons = styled.div`
  margin-top: 20px;

  ${setFlexDF};
`;
